// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"TopCampaignsReport_contentComponent__1nHMw","tableContainer":"TopCampaignsReport_tableContainer__3yAD9","totalRow":"TopCampaignsReport_totalRow__32Fn2"};